import { brandName, brandSlogan, heroChips, trending } from "@/mocks/gossip";

const stats = [
  { num: "516", label: "深度解析专题", icon: "ri-book-open-line" },
  { num: "28万", label: "理性吃瓜读者", icon: "ri-user-heart-line" },
  { num: "312", label: "信源纠错采纳", icon: "ri-feedback-line" },
];

export default function Hero() {
  const focus = trending.slice(0, 3);
  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      {/* decorative tint */}
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-[radial-gradient(60rem_28rem_at_85%_-5%,oklch(var(--primary-500)/0.12),transparent_60%)]"></div>
      <div aria-hidden className="pointer-events-none absolute -left-24 top-24 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>

      <div className="relative mx-auto max-w-6xl px-4 pb-14 pt-10 md:px-6 md:pb-20 md:pt-14">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-8">
          {/* left copy */}
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-verified-badge-fill h-3.5 w-3.5"></i>
              深扒内幕 · 真相还原 · 背后故事
            </span>
            <h1 className="mt-5 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 sm:text-5xl md:text-6xl">
              想吃透瓜的来龙去脉
              <span className="mt-1 block text-primary-600">先来 {brandName}</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-8 text-foreground-700 md:text-lg">
              我们专注<b className="font-semibold text-foreground-900">深扒内幕细节</b>、还原事件真相，挖掘背后不为人知的故事。从线索拼接到深度解析，
              给你一套完整吃透大瓜的视角，满足你对深层内幕的全部好奇。记住口号——
              <span className="font-semibold text-primary-700">{brandSlogan}</span>。
            </p>

            <ul className="mt-6 flex flex-wrap gap-2" aria-label="核心关键词">
              {heroChips.map((c) => (
                <li key={c} className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-sm text-foreground-800 ring-1 ring-background-200">
                  {c}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-fire-line h-4 w-4"></i>
                去看看今日热榜
              </a>
              <a
                href="#featured"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-100 px-6 py-3 text-sm font-semibold text-secondary-800 transition-colors hover:bg-secondary-200"
              >
                打开深扒专题
                <i className="ri-arrow-right-line h-4 w-4"></i>
              </a>
            </div>
          </div>

          {/* right focus panel */}
          <div className="lg:col-span-5">
            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-focus-3-line h-4 w-4 text-primary-600"></i>
                  本期焦点
                </h3>
                <a href="#featured" className="flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700">
                  全部专题
                  <i className="ri-arrow-right-line h-3.5 w-3.5"></i>
                </a>
              </div>
              <ul className="mt-4 space-y-3">
                {focus.map((t) => (
                  <li key={t.rank}>
                    <a href="#featured" className="group flex items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-background-50">
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                          t.rank === 1 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        {String(t.rank).padStart(2, "0")}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                          {t.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
                          <i className="ri-fire-fill h-3 w-3 text-primary-500"></i>
                          {t.heat}
                          <span className="rounded bg-accent-100 px-1.5 py-0.5 text-accent-700">{t.category}</span>
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* stat strip */}
        <dl className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((s) => (
            <div key={s.label} className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${s.icon} h-6 w-6`}></i>
              </span>
              <div>
                <dd className="font-heading text-2xl font-black text-foreground-950">{s.num}</dd>
                <dt className="text-xs text-foreground-600">{s.label}</dt>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}